import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantRoutes = [
	{ // login
		path: '/',
		component: () => import('@/pages/login'),
		hidden: true
	},
	{ // 根目录
		path: '/homepage',
		component: () => import('@/components/homepage'),
		hidden: true,
		children:[
			{ // device
				path: '/homepage/deviceinfo',
				component: () => import('@/components/deviceinfo'),
				hidden: true
			},
			{ // package
				path: '/homepage/packageinfo',
				component: () => import('@/components/packageinfo'),
				hidden: true
			},
			{ // update
				path: '/homepage/updatelog',
				component: () => import('@/components/updatelog'),
				hidden: true
			},
		]
	},
  	{ path: '*', redirect: '/', hidden: true }

]

const createRouter = () => new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRoutes
})

const router = createRouter()

// 导航守卫
router.beforeEach((to, from, next) => {
	if (to.path === '/') {
		next();
	}else {
		let token = localStorage.getItem('Authorization');
		next();
		
	}
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router
